import { Injectable } from '@angular/core';
import { AccountData } from '../types/AccountData';
import { Product } from '../types/Product';

@Injectable()
export class CustomerDataService {
    public accountData: AccountData = new AccountData();
    public productData: Product[] = new Array<Product>();
    public username = "";
    public loginType = "";
    public priorRoute = "";
    public totalEntitlements = 0;
    public adminCustomerAccount = ""; // displayed in upper-right up screen for admins
    public adminCustomerAccountGuid = ""; // displayed in upper-right up screen for admins
    public adminCrmEndpoint = ""; // displayed in upper-right up screen for admins
   
    public reset(){
        this.accountData = new AccountData();
        this.productData = new Array<Product>();
        this.username = "";
        this.loginType = "";
        this.priorRoute = "";
        this.totalEntitlements = 0;
        // Clear the admin header fields too, otherwise the customer account name stays in the
        // header after logout (this service is a singleton and the header is never destroyed).
        this.adminCustomerAccount = "";
        this.adminCustomerAccountGuid = "";
        this.adminCrmEndpoint = "";
    }

    public switchAccount(id: string, name: string) {
        this.accountData.accountid = id;
        this.accountData.name = name;
    }
}